// extracted by css-extract-rspack-plugin
export default {"supplierSection":"j6mgytFT2QiiHrYG__supplierSection___","suppliersTable":"yPz7Zrvz0Y2vWNu0__suppliersTable___","contentRow":"EQKgfdBkuL4pg6sn__contentRow___"};